(function ($, Promise) {

    var jqxr;
    var monitors = [];

    // Constructor
    function VICCCloudAPI() {
    }

    VICCCloudAPI.prototype.requestPreview = function (lat, lng) {
      return new Promise($.proxy(function (resolve, reject) {

        if (jqxr && jqxr.abort) {
          jqxr.abort()
        }

        jqxr = $.ajax({
          type: "POST",
          url: "/api/preview/address",
          data: {
            lat: lat,
            lng: lng
          },
          dataType: 'json'
        });

        jqxr.then($.proxy(function (responseJSON) {

          if (responseJSON.hasImagery == false) {
            reject("No imagery available from Google Street View.");
            return;

          } else {
            Promise.all([
              this.monitorImageCreationPromise(responseJSON.originalUrl),
            ]).then($.proxy(function () {
              resolve(responseJSON);
            }, this));
          }

        }, this)).catch($.proxy(function (err) {
          reject(err)
        }, this));

      }, this));

    }

    VICCCloudAPI.prototype.requestVisualization = function (lat, lng) {
      return new Promise($.proxy(function (resolve, reject) {

        // this.clearMonitors();

        if (jqxr && jqxr.abort) {
          jqxr.abort()
        }

        jqxr = $.ajax({
          type: "POST",
          url: "/api/visualization/address",
          data: {
            lat: lat,
            lng: lng
          },
          dataType: 'json'
        });

        jqxr.then($.proxy(function (responseJSON) {

          if (responseJSON.hasImagery == false) {
            reject("No imagery available from Google Street View.");
            return;

          } else {
            Promise.all([
              this.monitorImageCreationPromise(responseJSON.wildfireUrl),
              this.monitorImageCreationPromise(responseJSON.floodUrl),
              this.monitorImageCreationPromise(responseJSON.smogUrl),
            ]).then($.proxy(function () {
              resolve(responseJSON);
            }, this));
          }

        }, this)).catch($.proxy(function (err) {
          reject(err)
        }, this));

      }, this));
    }

    VICCCloudAPI.prototype.monitorImageCreationPromise = function (url) {
      return new Promise($.proxy(function (resolve, reject) {
        this.monitorImageCreation(url, resolve);
      }, this));
    }

    VICCCloudAPI.prototype.monitorImageCreation = function (url, callback, id) {
      this.urlExists(url, $.proxy(function (exists) {
        if (exists) {
          if (id && monitors[id]) {
            clearTimeout(monitors[id]);
            monitors.pop();
          }
          callback();
        } else {
          if (id) {
            monitors[id] = setTimeout($.proxy(function () {
              this.monitorImageCreation(url, callback, id);
            }, this), 1000);
          } else {
            monitors.push(setTimeout($.proxy(function (id) {
              this.monitorImageCreation(url, callback, id);
            }, this, monitors.length), 1000));
          }
        }
      }, this));
    }

    VICCCloudAPI.prototype.clearMonitors = function () {
      for (var i = monitors.length - 1; i >= 0; i--) {
        if (monitors[i]) {
          clearTimeout(monitors[i]);
          monitors.pop();
        }
      }
    }

    VICCCloudAPI.prototype.urlExists = function (url, callback) {

      $.ajax({
        url: url,
        type: "HEAD",
        error: function (error) {
          //file not exists
          callback(false);
        },
        success: function () {
          //file exists
          callback(true);
        }
      });

    }

    // Expose VICCCloudAPI
    window.VICCCloudAPI = VICCCloudAPI;
  }
)
(jQuery, Promise);
